<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import locale from 'element-ui/lib/locale'
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
export default {
  data() {
    return { lang: 'zh' }
  },
  methods: {},
  mounted() {
    this.lang = localStorage.getItem('lang') || 'zh'
    this.$i18n.locale = this.lang
    if (this.lang === 'zh') {
      locale.use(zh)
    } else {
      locale.use(en)
    }
  }
}
</script>
<style>
html,
body {
  height: 100%;
}
#app {
  font-size: 14px;
  height: 100%;
}
</style>
